import { Col, Form, Row } from "antd";
import { MazakaForm } from "apps/Common/MazakaForm";
import useMazakaForm from "hooks/useMazakaForm";
import { GeneralAddOrUpdateFormProps } from "models/Client/GeneralAddOrUpdate";
import { FC, } from "react";
// import { updateInviteStatus } from "../Services";
import { MazakaSelect } from "apps/Common/MazakaSelect";
import { acceptInviteStatus, rejectInviteStatus } from "../Services";
import { getUserInfoes } from "apps/CustomerPanel/Profile/Services";
import { handleSetUserInfoes } from "apps/CustomerPanel/Profile/ClientSideStates";
import { useDispatch } from "react-redux";

const UpdateInviteStatus: FC<GeneralAddOrUpdateFormProps> = ({
  selectedRecord,
  onFinish,
}) => {
  const [form] = Form.useForm();
  const { mazakaForm, formActions } = useMazakaForm(form);
  const dispatch = useDispatch()
  const getUserInformations = async () => {
    try {
      const response: any = await getUserInfoes();
      dispatch(handleSetUserInfoes({ data: response.data }))
      
    } catch (error: any) {
    }
  };

  const handleOnFinish = async()=>{
    mazakaForm.setLoading()
    let formValues = form.getFieldsValue()
    try {
         formValues["status"] ===1?await acceptInviteStatus(selectedRecord):await rejectInviteStatus(selectedRecord)
        mazakaForm.setSuccess(2000,()=>"İşlemBaşarılı")
        if(formValues["status"] ===1)
        {
          getUserInformations()
        }
        onFinish()
    } catch (error:any) {
        mazakaForm.setFailed(2500,error?.message)
        console.log("somethings wrong during add or update favorite list")
    }
  }
  const statusOptions = [
    {label:"Kabul Et",value:1},
    {label:"Reddet",value:2},
  ]
  return (
    <>
      <Col xs={24}>
        <MazakaForm onFinish={handleOnFinish} form={form} {...formActions}>
          <Row gutter={[0,10]}>
            <MazakaSelect
            options={statusOptions}
              rules={[{ required: true, message: "" }]}
              label={"Davet Durumu"}
              xs={24}
              name={"status"}
              placeholder="Davet Durumu"
            />
            
          </Row>
        </MazakaForm>
      </Col>
    </>
  );
};

export default UpdateInviteStatus;
